<template>
   <div class="container-fluid" style="padding-top:2%">
            <!-- <div class="row">
                <div class="col-lg-12">
                    <div class="card card-block card-stretch card-height iq-welcome" :style="`background: url(${require('@/assets/images/layouts/mydrive/background.png')}) no-repeat scroll right center; background-color: #ffffff; background-size: contain;`">
                        <div class="card-body property2-content">
                            <div class="d-flex flex-wrap align-items-center">
                                <div class="col-lg-6 col-sm-6 p-0">
                                    <h3 class="mb-3">Welcome {{user.username}}</h3>
                                    <p class="mb-5">Welcome to our client portal, this client portal consists of all games details and winning video.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <br> -->
            <div class="container p-0 justify-content-center">
                <div class="col-lg-8" >
                    <div class="card card-block card-stretch card-transparent">
                        <div class="card-header d-flex justify-content-between">
                            <div class="header-title" style="padding-left: 3%">
                                <h4 class="card-title">News</h4>
                            </div>
                            <nav class="navbar navbar-expand-lg">
                                <div class="collapse navbar-collapse" id="navbarNav">
                                    <ul class="navbar-nav" v-on:click="tag($event)" >
                                        <li class="nav-item" >
                                            <a class="nav-link" ref="all" id="all">All</a>
                                        </li>
                                        <li class="nav-item" >
                                            <a class="nav-link" ref="NEW" id="NEW">New</a>
                                        </li>
                                        <li class="nav-item" >
                                            <a class="nav-link" ref="SLOT" id="SLOT" value= "SLOT">Slots</a>
                                        </li>
                                        <li class="nav-item">
                                            <a class="nav-link"  ref="ARCADE" id="ARCADE" value= "ARCADE">Arcades</a>
                                        </li>
                                        <li class="nav-item"  >
                                            <a class="nav-link" ref="PROMO" id="PROMO">Promotions</a>
                                        </li>
                                        <li class="nav-item"  >
                                            <a class="nav-link" ref="FISHING" id="FISHING">Fishing</a>
                                        </li>
                                    </ul>
                                </div>
                            </nav>
                        </div>
                        <template class="news-content" v-if="navCategory.length > 1">    
                            <div v-for="cat in navCategory" v-bind:key="cat.id" class="category" ref="category">
                                <nav class="navbar navbar-expand-lg">
                                    <div class="collapse navbar-collapse justify-content-center " id="navbarNav" style="background-color: #f26a0c; border-radius: 25px;">
                                        <ul class="navbar-nav">
                                            <li class="nav-item">
                                                <a class="nav-link text-white" href="#">{{cat}} <span class="sr-only">(current)</span></a>
                                            </li>
                                        </ul>
                                    </div>
                                </nav>
                                <div :id="'div-' + cat" :ref="'div-' + cat">
                                    <template class="news-content" v-for="item in newsForm">                               
                                        <div class="card-body" v-if="item.category.includes(cat)" v-bind:key="item.id" :id="'child-' + cat" :ref="'child-' + cat">
                                            <b-card-group deck :key="item.id">
                                                <b-card :title="item.title" :img-src="item.image" img-alt="Image" img-top>
                                                    <b-card-text>
                                                        {{item.short_description | truncate(300, '...')}}
                                                    </b-card-text>
                                                    <b-card-text>
                                                        <small class="text-muted">{{item.start_date}}</small>
                                                        <b-button v-bind:href="'/news/detail?id='+ item.id" pill variant="primary" class="text-white float-right">read more</b-button>
                                                    </b-card-text>
                                                </b-card>
                                            </b-card-group>                                        
                                        </div>                                
                                    </template>
                                </div>
                            </div>
                        </template>
                        <template class="news-content" v-if="navCategory.length === 1">   
                            <div v-for="cat in navCategory" v-bind:key="cat.id" class="category" ref="category">
                                <nav class="navbar navbar-expand-lg">
                                    <div class="collapse navbar-collapse justify-content-center " id="navbarNav" style="background-color: #f26a0c; border-radius: 25px;">
                                        <ul class="navbar-nav">
                                            <li class="nav-item">
                                                <a class="nav-link text-white" href="#">{{cat}} <span class="sr-only">(current)</span></a>
                                            </li>
                                        </ul>
                                    </div>
                                </nav>
                                <div :id="'div-' + cat" :ref="'div-' + cat">
                                    <template class="news-content" v-for="item in newsForm">                               
                                        <div class="card-body" v-if="item.category.includes(cat)" v-bind:key="item.id" :id="'child-' + cat" :ref="'child-' + cat">
                                            <b-card-group deck :key="item.id">
                                                <b-card :title="item.title" :img-src="item.image" img-alt="Image" img-top>
                                                    <b-card-text>
                                                        {{item.short_description | truncate(300, '...')}}
                                                    </b-card-text>
                                                    <b-card-text>
                                                        <small class="text-muted">{{item.start_date}}</small>
                                                        <b-button v-bind:href="'/news/detail?id='+ item.id" pill variant="primary" class="text-white float-right">read more</b-button>
                                                    </b-card-text>
                                                </b-card>
                                            </b-card-group>                                        
                                        </div>                                
                                    </template>
                                </div>
                            </div>
                            <div class="no-content justify-content-center" v-if="this.newsForm.length <= 0">
                                <h5 style="text-align : center">
                                    No Content At This Moment
                                </h5>
                            </div> 
                        </template>                     
                    </div>
                </div>
                <div class="news-sidebar col-sm-3">
                    <div class="side-card iq-mb-3"  v-for="item in newsUpcoming" v-bind:key="item.id">
                        <div class="card-header bg-dark">Upcoming News</div>
                        <div class="card-body bg-light">
                            <b-card-img :src="item.image" style="width: 100%; "></b-card-img>
                                <b-card-text>
                                    <strong>{{item.title}} </strong>
                                    <br>
                                    <small>{{item.start_date}}</small>
                                </b-card-text>
                                <b-button v-bind:href="'/news/detail?id='+ item.id"  block variant="primary">Go</b-button>    
                        </div>
                    </div>
                    <div class="side-card iq-mb-3" v-for="item in latestRelease" v-bind:key="item.id">
                        <div class="card-header bg-dark">Latest Release</div>
                        <div class="card-body bg-light">
                            <b-card-img :src="getImgUrl(item.code)" style="width: 70%; "></b-card-img>
                                <b-card-text>
                                    <strong>{{item.name}} </strong>
                                    <br>
                                    <small>{{item.releaseDate}}</small>
                                </b-card-text>
                                <b-button v-bind:href="'/'+item.category+'/game-detail?code='+ item.code"  block variant="primary">Go</b-button> 
                        </div>
                    </div>

                    <div class="side-card iq-mb-3" v-for="item in promoUpcoming" v-bind:key="item.id">
                        <div class="card-header bg-dark">Upcomimg Promo</div>
                        <div class="card-body bg-light">
                            <b-card-img :src="item.image" style="width: 100%; "></b-card-img>
                                <b-card-text>
                                    <strong>{{item.title}} </strong>
                                    <br>
                                    <small>{{item.start_date}}</small>
                                </b-card-text>
                                <!-- <h6>{{item.releaseDate}}</h6>  -->
                                <b-button v-bind:href="'/news/detail?id='+ item.id"  block variant="primary">Go</b-button>
                        </div>
                    </div>

                </div>
            </div>
    </div>
</template>

<style>
    .container{
        display: flex;
    }
    .card-body .card{
         /* box-shadow: 5px 10px; */
        box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);
        transition: 0.3s;
    }

    .side-card{
        box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);
        transition: 0.3s;
        text-align: center;
        max-width: 12rem;
    }
    

    /* On mouse-over, add a deeper shadow */
    .card-body .card:hover {
        box-shadow: 0 8px 16px 0 rgba(0,0,0,0.2);
    }

    .side-card {
        box-shadow: 0 8px 16px 0 rgba(0,0,0,0.2);
    }

    #news-content {
        display: flex;
        width: 100%;
    }

    .navbar-nav {
        cursor: pointer;
    }
    .nav-link.active {
        color:  #f26a0c !important;
        font-weight: bold;
    }
    .category .news-content:empty::before {
       content: "No Content At this Moment";
    }
</style>

<script>
import axios from 'axios';
import moment from 'moment';
import Vue from 'vue';
import VueAxios from 'vue-axios';

const config = require("../../../../config");
Vue.use(VueAxios, axios, moment )

export default {
    name:'Dashbord1',
    components:{
    },
    data(){
        return {
            user: {
                username: ''
            },
            newsForm:[],
            allNews:[], 
            navCategory:[],
            allCategory:[],
            newsUpcoming: [],
            latestRelease:[],
            promoUpcoming:[],
            activeColor: 'red',
            content: false,
            childcount: 0 
                      
        }
    },
    mounted: async function() {
        this.user = JSON.parse(localStorage.getItem('user'));

        var filter = function(text, length, clamp){ 
            clamp = clamp || '...';
            var node = document.createElement('div');
            node.innerHTML = text;
            var content = node.textContent;
            return content.length > length ? content.slice(0, length) + clamp : content;
        };

        Vue.filter('truncate', filter);

        try {
            const res = await axios.get(config.api.URL + '/api/news/latest', {
                params: {
                m: this.$route.meta.uid,
                category: "all"
                }
            });

            res.data.cat_order.forEach(element => {
                this.navCategory.push(element.category);
                this.allCategory.push(element.category);
            });

            /*latest game release checking */
            this.latestRelease.push(res.data.latest_game[0] )

            this.latestRelease.forEach(element => {
                if (element.category == 'SLOT') {
                    element.category = 'slots'                 
                } else {
                    element.category = element.category.toLowerCase()
                }               
            });

            res.data.news_latest.forEach(element => {
                element.image = config.api.URL + element.image
            });

            const dates = []

            // /*upcoming news checking */
            res.data.news_latest.forEach(element => {

                element.category.split(",")
                var releaseDate = moment(element.start_date).format("YYYY/M/DD");
                var currDate = this.currentDate()
                var date2Obj = new Date(releaseDate)
                var cur2Obj = new Date(currDate)

                var before = moment(date2Obj).isBefore(moment(cur2Obj).format("YYYY/MM/DD"))
                var same = moment(date2Obj).isSame(moment(cur2Obj).format("YYYY/MM/DD"))


                if(before === true || same === true) {

                    this.newsForm.push(element)
                    this.allNews.push(element)
                } 
                
                if(before === false && same === false && element.category !== "PROMO"){
                    dates.push(moment(date2Obj))
                    this.newsUpcoming.push(element)
                }

                if(element.category === "PROMO"){
                        if(before === false && same === false){
                        this.promoUpcoming.push(element)
                    }
                }     
            });

            var minDate = new Date(Math.min.apply(null, dates));
           
            this.newsUpcoming.forEach(element => {
                if (moment(element.start_date).isSame(moment(minDate).format("YYYY/MM/DD"))) {
                    this.newsUpcoming = []
                    this.newsUpcoming.push(element)
                }
            });
        
            this.$refs.all.classList.add('active');

            this.$nextTick(function () {
                this.findContent()
            })

        } catch(error) {
            alert("Error: Unable to retrieve data");
            console.log("Error: ", error)
        }
    },
    methods: {
        findContent(){
            this.allCategory.forEach(element => {
                const el = this.$refs["div-"+ element];
                this.childcount = el[0].children.length

                if (el[0].outerText === '') {
                    el[0].innerHTML ="<div style=' text-align : center; padding: 30px';>" + "No Content At This Moment" + "</div>"               
                }

                for (let index = 0; index < el[0].children.length; index++) {
                    const element = el[0].children[index];
                    if (index >= 2) {
                        element.remove()
                    }
                }
            });
        },
        noContent(){
             const el = this.$refs.category;
             if (el.length <= 0) {
                this.content = true
             }
        },
        currentDate() {
            const current = new Date();
            const date = `${current.getFullYear()}/${current.getMonth()+1}/${current.getDate()}`;
            return date;
        },
        
        tag:async function(event) {
            const category = event.target.id;   
            
            if (category === "all" ) {
                this.$refs.all.classList.add('active');
            }else{
                this.$refs.all.classList.remove('active');
            }

             if (category === "NEW") {
                this.$refs.NEW.classList.add('active');
            }else{
                this.$refs.NEW.classList.remove('active');
            }

            if (category === "SLOT") {
                this.$refs.SLOT.classList.add('active');
            }else{
                this.$refs.SLOT.classList.remove('active');
            }

             if (category === "ARCADE") {
                this.$refs.ARCADE.classList.add('active');
            }else{
                this.$refs.ARCADE.classList.remove('active');
            }

            if (category === "PROMO") {
                this.$refs.PROMO.classList.add('active');
            }else{
                this.$refs.PROMO.classList.remove('active');
            }
            
            if (category === "all") {
                this.newsForm = this.allNews
                this.navCategory = this.allCategory
                this.$nextTick(function () {
                    this.findContent()
            })

            } else {
               const res = await axios.get(config.api.URL + '/api/news/latest', {
                    params: {
                    m: this.$route.meta.uid,
                    category: category
                    }
                });
                this.newsForm = res.data.news_category
                this.navCategory = []
                this.navCategory.push(category);
               
                this.newsForm.forEach(element => {
                    var cat = element.category
                    element.image = config.api.URL + element.image

                    for(var i=0; i < this.navCategory.length; i++){
                        if( this.navCategory[i] == cat){
                            return cat
                        }
                    }
                }); 
                this.$nextTick(function () {
                    this.noContent()
                })     
            }  
        },
        getImgUrl(gameCode) {
            try {
                return require('../../../../static/images/gamepic/'+gameCode+'_350x350.jpg');
            } catch (error) {
                return require('../../../assets/images/NS_Black_cleaned.svg');
            }
        }
                   
    },

    computed:{

    }

}
</script>
